import { useEffect, useState, useRef,useContext, Fragment } from 'react'
import {useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import BankContext from '../Context/bank'
import LangContext from '../Context/lang';





const Search = () => {

  // let { keywords } = useParams();
  const navigate = useNavigate();

  const { GetTaksitPrice,bankActive} = useContext(BankContext);
  const { Lang, NavMenu ,Global,ProductLang} = useContext(LangContext);



  // console.log(keywords);

  const isInitialMount = useRef(true);
  const isInitialMountCat = useRef(true);



  const [searchParams, setSearchParams] = useSearchParams();
  const keyQuery = searchParams.get('key');
  const [keywords, setkeywords] = useState(keyQuery !== null && keyQuery !== undefined && keyQuery !== '' ? keyQuery : "")
  const pageQuery = searchParams.get('page');
  const MarkQueryParams = searchParams.get('marque');
  const CatQueryParams = searchParams.get('parent');
  const subCatQueryParams = searchParams.get('categorie');

  // console.log(pageQuery)
  // console.log(MarkQueryParams);
  // console.log(CatQueryParams);
  // setSearchParams({page:"2"})

  const SkeletonArray = [65, 44, 12, 4, 65, 44, 12, 4, 65, 44, 12, 4, 44, 12, 4, 65, 44, 12, 4];


  const [SearchData, setSearchData] = useState([])
  const [PageNumber, setPageNumber] = useState(0)
  const [CurrentPage, setCurrentPage] = useState(pageQuery !== "" ? pageQuery : 1)
  const [search, setsearch] = useState(keywords !== null && keywords !== undefined && keywords !== '' ? keywords : "")
  const [Loading, setLoading] = useState(true)

  const [CategoriesList, setCategoriesList] = useState([])
  const [Categorie, setCategorie] = useState(CatQueryParams !== '' ? CatQueryParams : '')
  const [LoadingCat, setLoadingCat] = useState(true)

  // console.log(search);


  function Pagination(type, number) {

    if (type === "firstPage") {
      // setCurrentPage(1)
      setSearchParams({ page: 1, ...(search && { key: search }), ...(Markquery && { marque: Markquery }), ...(Categorie && { parent: Categorie }), ...(Categorie && SousCategories && { categorie: SousCategories }) })
    }

    if (type === "lastPage") {
      // setCurrentPage(PageNumber)
      setSearchParams({ page: PageNumber, ...(search && { key: search }), ...(Markquery && { marque: Markquery }), ...(Categorie && { parent: Categorie }), ...(Categorie && SousCategories && { categorie: SousCategories }) })
    }

    if (type === "allPage") {
      // setCurrentPage(number)
      setSearchParams({ page: number, ...(search && { key: search }), ...(Markquery && { marque: Markquery }), ...(Categorie && { parent: Categorie }), ...(Categorie && SousCategories && { categorie: SousCategories }) })
    }

    if (type === "Back") {
      // setCurrentPage(number)
      setSearchParams({ page: number, ...(search && { key: search }), ...(Markquery && { marque: Markquery }), ...(Categorie && { parent: Categorie }), ...(Categorie && SousCategories && { categorie: SousCategories }) })
    }

    if (type === "Next") {
      // setCurrentPage(number)
      setSearchParams({ page: number, ...(search && { key: search }), ...(Markquery && { marque: Markquery }), ...(Categorie && { parent: Categorie }), ...(Categorie && SousCategories && { categorie: SousCategories }) })
    }

  }


  const [Mark, setMark] = useState([]);
  const [GetMarkParams, setGetMarkParams] = useState(MarkQueryParams !== null ? MarkQueryParams.split(',') : [])
  const [MarkChecked, setMarkChecked] = useState(MarkQueryParams !== null ? MarkQueryParams.split(',') : []);
  // console.log(MarkQueryParams);
  // console.log(MarkChecked);
  const [Markquery, setMarkquery] = useState(MarkChecked.length > 0 && MarkChecked.join())

  const handleChange = (event) => {

    if (!event.target.checked) {

      setMarkChecked(MarkChecked.filter(item => item !== event.target.name))

    } else {
      setMarkChecked((prev) => [...prev, event.target.name]);
    }
    // console.log(MarkChecked);

  }

  useEffect(() => {

    setMarkquery(MarkChecked.length > 0 && MarkChecked.join())
    // console.log('firrrrrrrrrrrrrrrrreeeeeeeeeeee 0');

    // setMarkquery(Object.keys(MarkChecked).reduce((a, c) => {
    //   if (MarkChecked[c] === true) {
    //     a.push(c);
    //   }
    //   return a;
    // }, []))


  }, [MarkChecked])


  useEffect(() => {

    setMarkChecked(MarkQueryParams !== null ? MarkQueryParams.split(',') : [])



  }, [MarkQueryParams])

  useEffect(() => {

    setCategorie(CatQueryParams !== '' ? CatQueryParams : '')
    // console.log('fire cattttt ');
    // console.log(Categorie);
    // console.log(CatQueryParams);




  }, [CatQueryParams])

  useEffect(() => {

    setSousCategories(subCatQueryParams !== '' ? subCatQueryParams : '')



  }, [subCatQueryParams])
  useEffect(() => {

    setCurrentPage(pageQuery)



  }, [pageQuery])

  useEffect(() => {

    setsearch(keywords !== null && keywords !== undefined && keywords !== '' ? keywords : "")

  }, [keywords,subCatQueryParams,CatQueryParams,MarkQueryParams])


  // useEffect(() => {

  //   setCurrentPage(pageQuery)
  //   // setMarkquery(Object.keys(MarkChecked).reduce((a, c) => {
  //   //   if (MarkChecked[c] === true) {
  //   //     a.push(c);
  //   //   }
  //   //   return a;
  //   // }, []))


  // }, [pageQuery])


  // useEffect(() => {

  //   if (isInitialMount.current) {
  //     isInitialMount.current = false;
  //   } else {
  //     setSearchParams({ page: 1, ...(Markquery && { marque: Markquery }) })

  //   }



  //   // setMarkquery(MarkChecked.length > 0 && MarkChecked.join())
  //   // setMarkquery(Object.keys(MarkChecked).reduce((a, c) => {
  //   //   if (MarkChecked[c] === true) {
  //   //     a.push(c);
  //   //   }
  //   //   return a;
  //   // }, []))


  // }, [Markquery])




  function filter() {

    setMarkquery(MarkChecked.length > 0 ? MarkChecked.join() : '')
    setSearchParams({ page: 1, ...(Markquery && { marque: Markquery }) })
    const keywordfilter = search.trim() !== '' && search.trim() !== null && search.trim() !== undefined ? search.trim() : '';

    // navigate("/search/" + keywordfilter + "?page=1&marque="+Markquery)
    // navigate(0)

  }


  const [LoadingMark, setLoadingMark] = useState(true)
  useEffect(() => {
    axios.get('https://diardzair.com.dz/ws/homepage/slides?type=marque').then(response => {
      // console.log(response.data[0])
      setMark(response.data[0])
      setLoadingMark(false)
      // console.log(Mark)
    });
  }, []);



  // console.log(Categorie);

  useEffect(() => {

    const fetchData = async () => {
      // setLoading(true);
      try {
        const { data: response } = await axios.get(`https://diardzair.com.dz/ws/dartaksit-categories`);
        // console.log(response[0]);
        setCategoriesList(response[0]);
        setLoadingCat(false)
        // console.log(CategoriesList)

      } catch (error) {
        // console.error(error.message);
      }
      // setLoading(false);
    }

    fetchData();

  }, []);





  const [SousCategoriesList, setSousCategoriesList] = useState([])
  const [SousCategories, setSousCategories] = useState(subCatQueryParams !== '' ? subCatQueryParams : '')

  // console.log(SousCategories);

  useEffect(() => {

    const GetSousCategories = async () => {
      try {
        const { data: response } = await axios.get(`https://diardzair.com.dz/ws/categorie?unicnom=${Categorie}`);
        // console.log(response);
        setSousCategoriesList(response[0])
        if (isInitialMountCat.current) {
          isInitialMountCat.current = false;
        } else {
          setSousCategories('')
        }
      } catch (error) {
        console.error(error.message);
      }
    }

    if (Categorie !== '') {
      GetSousCategories();
    }


  }, [Categorie])



  useEffect(() => {

    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      const Catqueryuri = Categorie !== '' && Categorie !== undefined && Categorie !== null ? '&parent=' + Categorie : '';
      const SousCatqueryuri = SousCategories !== '' && SousCategories !== undefined && SousCategories !== null && Categorie !== '' && Categorie !== undefined && Categorie !== null ? '&categorie=' + SousCategories : '';
      const Markuri = Markquery !== '' && Markquery !== undefined && Markquery !== null && Markquery !== false ? '&marque=' + Markquery : '';


      // navigate("/search/?key=" +search + "&page=1"+Markuri+Catqueryuri+SousCatqueryuri)
      // return navigate(0)
      setSearchParams({ page: 1, ...(search && { key: search }), ...(Markquery && { marque: Markquery }), ...(Categorie && { parent: Categorie }), ...(Categorie && SousCategories && { categorie: SousCategories }) })
      // setCurrentPage(1)

      // console.log('firrrrrrrrrrrrrrrrreeeeeeeeeeee');
    }



    // setMarkquery(MarkChecked.length > 0 && MarkChecked.join())
    // setMarkquery(Object.keys(MarkChecked).reduce((a, c) => {
    //   if (MarkChecked[c] === true) {
    //     a.push(c);
    //   }
    //   return a;
    // }, []))


  }, [Categorie, Markquery, SousCategories])



  useEffect(() => {
    // console.log('%c Oh my heavens hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh! ', 'background: #222; color: #bada55;font-size:30px;');

    // console.log(Categorie);
    const Catqueryuri = Categorie !== '' && Categorie !== undefined && Categorie !== null ? '&parent=' + Categorie : '';
    const SousCatqueryuri = Categorie !== '' && Categorie !== undefined && Categorie !== null && SousCategories !== '' && SousCategories !== undefined && SousCategories !== null ? '&categorie=' + SousCategories : '';

    const fetchData = async () => {
      setLoading(true);
      try {


        const { data: response } = await axios.get(`https://diardzair.com.dz/ws/searchText?q=${(keywords !== undefined && keywords.trim() !== '' ? encodeURIComponent(keywords) : "")}&page=${pageQuery}&marque=${Markquery !== false ? Markquery : ''}${Catqueryuri}${SousCatqueryuri}`);

        // console.log(typeof response[0]);
        // console.log(response);
        if (response['errorCode'] == 5) {
          navigate("/search/?page=1")
          navigate(0)

        }
        if (typeof response[0] == 'object') {


          setSearchData(response[0]);
          console.log(response[0]);
          if (response[0].length > 0) {

            setPageNumber(response['pageTotal'])
            setCurrentPage(response['page'])
            // console.log('errrrr' + response['page']);
          } else {

            setPageNumber(0)
            setCurrentPage(1)

          }
          // console.log(CurrentPage)
          // console.log(PageNumber);
        } else {
          navigate("/search/?page=1")
          navigate(0)

        }
        setLoading(false)

      } catch (error) {
        // console.error(error.message);
      }
      // setLoading(false);
    }

    fetchData();
    // console.log(`https://diardzair.com.dz/ws/searchText?q=${(keywords !== undefined ? encodeURIComponent(keywords) : "")}&page=${CurrentPage}&marque=${Markquery !== false ? Markquery : ''}${Catqueryuri}${SousCatqueryuri}`);
    // console.log(`https://diardzair.com.dz/ws/searchText?q=${(keywords !== undefined ? keywords : "p")}&page=${pageQuery}&marque=${Markquery !== false ? Markquery : ''}${Catqueryuri}`);
    // console.log(`https://diardzair.com.dz/ws/searchText?q=${(keywords !== undefined && keywords.trim() !== '' ? encodeURIComponent(keywords) : "")}&page=${pageQuery}&marque=${Markquery !== false ? Markquery : ''}${Catqueryuri}${SousCatqueryuri}`);

  }, [keywords, pageQuery, MarkQueryParams, CatQueryParams, subCatQueryParams]);


  function SearchQuery(e) {
    // setsearch(e.target.value)
    // setCurrentPage(1)

    if (search.trim() !== "") {

      window.location.href = "/search/?key=" + encodeURIComponent(search.trim()) + "&page=1";

      // navigate()
      // navigate(0)
      // setsearch("");
    } else {
      window.location.href = "/search/?page=1";

      // navigate("/search/?page=1")
      // navigate(0)
      // setsearch("");
    }

  }

  return (
    <div className='search-page'>
      <div className=''></div>
      <div className='search-area' style={{ background : `linear-gradient(45deg, #f33f6959, #ffffff4d), url('https://thumbs.dreamstime.com/b/red-gift-box-banner-christmas-valentine-s-day-background-231264121.jpg')`  , backgroundRepeat: 'no-repeat !important' , backgroundSize: 'cover !important'}}>
        <div className='container'>
          <div className='titel'>{NavMenu['search'][Lang]}</div>
          <div className="d-flex justify-content-center px-md-5"> <div className="search">
            <input type="search" onKeyPress={event => event.key === 'Enter' && SearchQuery()} className="search-input" onChange={e => setsearch(e.target.value)} placeholder={NavMenu['searchbar'][Lang]} value={search} />
            <a aria-label="Search" onClick={() => SearchQuery()} href="#" className="search-icon"> <i className="fa fa-search" /> </a> </div> </div>
        </div>
      </div>
      <div className='container-fluid'>
        {/* <input type="search" onChange={e => SearchQuery(e) } className="form-control input-search-dd mb-5" placeholder="Que recherchez-vous ?" aria-label="Search" aria-describedby="search-addon" /> */}

        <div className='row'>
        <section className='mobile-dar-taksit-cat d-flex d-lg-none mb-3' data-bs-toggle="offcanvas" href="#offcanvasExamplesearch" role="button" aria-controls="offcanvasExamplesearch">
        <div>
          <svg className='me-3' xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path id="category-15" d="M101.675,107.049a4.689,4.689,0,1,1,3.3-1.373A4.634,4.634,0,0,1,101.675,107.049Zm0-8.193a3.518,3.518,0,1,0,3.518,3.518A3.522,3.522,0,0,0,101.675,98.857Zm0,18.843a4.689,4.689,0,1,1,3.3-1.373A4.634,4.634,0,0,1,101.675,117.7Zm0-8.193a3.518,3.518,0,1,0,3.518,3.518A3.522,3.522,0,0,0,101.675,109.507Zm12.337,8.193h-3.374a2.991,2.991,0,0,1-2.988-2.988v-3.374a.578.578,0,0,1,1.157,0v3.374a1.834,1.834,0,0,0,1.831,1.831h3.374a1.834,1.834,0,0,0,1.831-1.831v-3.374a1.834,1.834,0,0,0-1.831-1.831h-3.374a.578.578,0,0,1,0-1.157h3.374A2.991,2.991,0,0,1,117,111.339v3.374A2.991,2.991,0,0,1,114.012,117.7Zm-1.687-10.651a4.689,4.689,0,1,1,3.3-1.373A4.634,4.634,0,0,1,112.325,107.049Zm0-8.193a3.518,3.518,0,1,0,3.518,3.518A3.522,3.522,0,0,0,112.325,98.857Z" transform="translate(-97 -97.7)" fill="#fff" />
          </svg>
          <span>{(Lang === 'ar' ? 'تخصيص' : 'Filtre')}</span>
        </div>
        <div> {(Lang === 'ar' ? 'شاهد' : 'Voir')}</div>

      </section>
      <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasExamplesearch" aria-labelledby="offcanvasExampleLabel2">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel2">{(Lang === 'ar' ? 'تخصيص' : 'Filtre')}</h5>
          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
        </div>
        <div className="offcanvas-body">

        {
              LoadingCat &&



              <Skeleton height={200} borderRadius={20} />



            }
            <div className={LoadingCat ? 'd-none' : 'sidebar-wrapper  sidebar--categories'}>
              <h5 className="sidebarBlock-heading"><svg xmlns="https://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                <path id="category-15" d="M102.843,109.387a5.862,5.862,0,1,1,4.127-1.717A5.792,5.792,0,0,1,102.843,109.387Zm0-10.241a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,102.843,99.146Zm0,23.554a5.862,5.862,0,1,1,4.127-1.717A5.793,5.793,0,0,1,102.843,122.7Zm0-10.241a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,102.843,112.459ZM118.265,122.7h-4.217a3.738,3.738,0,0,1-3.735-3.735v-4.217a.723.723,0,0,1,1.446,0v4.217a2.292,2.292,0,0,0,2.289,2.289h4.217a2.292,2.292,0,0,0,2.289-2.289v-4.217a2.292,2.292,0,0,0-2.289-2.289h-4.217a.723.723,0,0,1,0-1.446h4.217A3.738,3.738,0,0,1,122,114.748v4.217A3.738,3.738,0,0,1,118.265,122.7Zm-2.108-13.313a5.862,5.862,0,1,1,4.126-1.717A5.793,5.793,0,0,1,116.157,109.387Zm0-10.241a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,116.157,99.146Z" transform="translate(-97 -97.7)" fill="#ed335b" />
              </svg>
              {(Lang === 'ar' ? 'التصنيفات' : 'Catégories')}</h5>
              {/* <div>

              {CategoriesList.length > 0 && CategoriesList.map((item,i) => ( 
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" defaultValue id={`flexCheckDefault${item.nom}`} />
                  <label className="form-check-label search-checkbox" htmlFor={`flexCheckDefault${item.nom}`}>
                    {item.nom}
                  </label>
                </div>                  
              ))
              }
              </div> */}
              <div className="col-md-12 mb-3 mt-5">
                {/* <label htmlFor="inputEmail4" className="form-label">Wilaya</label> */}
                <select className="form-select" value={Categorie || ''} aria-label="Default select example" onChange={(e) => setCategorie(e.target.value)}>
                  <option value={''} disabled>{(Lang === 'ar' ? 'التصنيفات' : 'Catégories')}</option>

                  {CategoriesList.length > 0 &&

                    <option value={''}>{Lang === 'ar' ? 'كل التصنيفات' : 'Tous Les Catégories'} </option>

                  }

                  <>
                    {CategoriesList.length > 0 && CategoriesList.map((item, i) => (

                      <option key={`SearchPageCategoriesMobile${item?.unicnom}`}  value={item?.nom !== "Pack" ? item?.unicnom : "Dar-Taksit"}>{(Lang === 'ar' ? item?.nomAr : item?.nom)}</option>
                    ))
                    }
                  </>

                </select>

              </div>
              <div className="col-md-12 mb-3">
                <select className={`form-select ${SousCategoriesList.length == 0 && 'd-none'}`} value={SousCategories || ''} aria-label="Default select example" onChange={(e) => setSousCategories(e.target.value)}>
                  {
                    SousCategoriesList.length == 0 && <option value={''} disabled >{(Lang === 'ar' ? 'الفئات الفرعية' : 'Sous Catégories')} </option>
                  }

                  {
                    SousCategoriesList.length > 0 && <option value={''} >{(Lang === 'ar' ? 'جميع الفئات الفرعية' : 'Tous Les Sous Catégories')} </option>
                  }

                  {SousCategoriesList.length > 0 && SousCategoriesList.map((item, i) => (
                    <option key={`SearchPagesubCategoriesMobile${item?.unicnom}`}  value={item?.unicnom}>{(Lang === 'ar' ? item?.nomAr : item?.nom)}</option>
                  ))
                  }
                </select>
              </div>

            </div>

            {
              LoadingMark &&


              <Skeleton height={314} borderRadius={20} />


            }
            <div className={LoadingMark ? 'd-none' : 'sidebar-wrapper  sidebar--categories mt-1'}>
              <h5 className="sidebarBlock-heading"><svg xmlns="https://www.w3.org/2000/svg" width="25.446" height="29" viewBox="0 0 25.446 29">
                <g id="mark_icon" data-name="mark icon" transform="translate(-81.65 -174.8)">
                  <path id="Tracé_211" data-name="Tracé 211" d="M96.872,174.8c.46.106.919.218,1.379.324,1.921.442,3.842.872,5.756,1.332a1.851,1.851,0,0,1,1.444,1.467q.813,3.447,1.585,6.894a2.04,2.04,0,0,1-.566,1.986Q100,193.289,93.513,199.764a1.465,1.465,0,0,1-2.168-.006q-4.613-4.6-9.209-9.2a1.465,1.465,0,0,1,0-2.18q6.46-6.46,12.915-12.921a2.2,2.2,0,0,1,1.243-.625.646.646,0,0,0,.1-.029Zm-4.431,23.962c.035-.029.077-.071.118-.112L104.013,187.2c.465-.465.937-.931,1.4-1.4a.67.67,0,0,0,.194-.648c-.518-2.268-1.049-4.537-1.567-6.811a.588.588,0,0,0-.489-.483q-3.367-.769-6.734-1.55a.738.738,0,0,0-.754.212L83.22,189.359c-.035.035-.065.071-.088.094Z" fill="#e0234f" />
                  <path id="Tracé_212" data-name="Tracé 212" d="M94.935,437.276a1.706,1.706,0,0,1-.813-.53Q89.384,432,84.636,427.26a.629.629,0,0,0-.136-.094c.194-.194.359-.359.56-.566a.868.868,0,0,0,.094.147q4.808,4.8,9.6,9.592c.283.283.436.283.719,0l13.316-13.316a.838.838,0,0,0,.1-.124l.524.524c-.012.012-.041.047-.071.082l-13.4,13.4a1.526,1.526,0,0,1-.654.377C95.17,437.276,95.052,437.276,94.935,437.276Z" transform="translate(-2.682 -233.482)" fill="#e0234f" />
                  <path id="Tracé_213" data-name="Tracé 213" d="M392.437,251.6a1.346,1.346,0,1,1-1.337,1.343A1.33,1.33,0,0,1,392.437,251.6Z" transform="translate(-291.217 -72.274)" fill="#e0234f" />
                </g>
              </svg>{(ProductLang['Marque'][Lang])}</h5>
              <div className='search-mark'>
                {
                  Mark.length > 0 && Mark.map((item, i) => (

                    <div key={`SearchPageMarkMobile${item?.title}`} className="form-check">
                      <input className="form-check-input" type="checkbox" name={item?.title} checked={MarkChecked.includes(item?.title)} onChange={handleChange} defaultValue id={`flexCheckDefaultMobile${item?.title}`} />
                      <label className="form-check-label search-checkbox" htmlFor={`flexCheckDefaultMobile${item?.title}`}>
                        {item?.title}
                      </label>
                    </div>
                  ))
                }



              </div>

            </div>

          
        </div>
      </div>
          <div className='col-12 col-lg-3 mb-5 d-none d-lg-block'>
            {
              LoadingCat &&



              <Skeleton height={200} borderRadius={20} />



            }
            <div className={LoadingCat ? 'd-none' : 'sidebar-wrapper  sidebar--categories'}>
              <h5 className="sidebarBlock-heading"><svg xmlns="https://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                <path id="category-15" d="M102.843,109.387a5.862,5.862,0,1,1,4.127-1.717A5.792,5.792,0,0,1,102.843,109.387Zm0-10.241a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,102.843,99.146Zm0,23.554a5.862,5.862,0,1,1,4.127-1.717A5.793,5.793,0,0,1,102.843,122.7Zm0-10.241a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,102.843,112.459ZM118.265,122.7h-4.217a3.738,3.738,0,0,1-3.735-3.735v-4.217a.723.723,0,0,1,1.446,0v4.217a2.292,2.292,0,0,0,2.289,2.289h4.217a2.292,2.292,0,0,0,2.289-2.289v-4.217a2.292,2.292,0,0,0-2.289-2.289h-4.217a.723.723,0,0,1,0-1.446h4.217A3.738,3.738,0,0,1,122,114.748v4.217A3.738,3.738,0,0,1,118.265,122.7Zm-2.108-13.313a5.862,5.862,0,1,1,4.126-1.717A5.793,5.793,0,0,1,116.157,109.387Zm0-10.241a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,116.157,99.146Z" transform="translate(-97 -97.7)" fill="#ed335b" />
              </svg>
              {(Lang === 'ar' ? 'التصنيفات' : 'Catégories')}</h5>
              {/* <div>

              {CategoriesList.length > 0 && CategoriesList.map((item,i) => ( 
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" defaultValue id={`flexCheckDefault${item.nom}`} />
                  <label className="form-check-label search-checkbox" htmlFor={`flexCheckDefault${item.nom}`}>
                    {item.nom}
                  </label>
                </div>                  
              ))
              }
              </div> */}
              <div className="col-md-12 mb-3 mt-4">
                {/* <label htmlFor="inputEmail4" className="form-label">Wilaya</label> */}
                <select className="form-select" value={Categorie || ''} aria-label="Default select example" onChange={(e) => setCategorie(e.target.value)}>
                  <option value={''} disabled >{(Lang === 'ar' ? 'التصنيفات' : 'Catégories')}</option>

                  {CategoriesList.length > 0 &&

                    <option value={''}>{Lang === 'ar' ? 'كل التصنيفات' : 'Tous Les Catégories'} </option>

                  }

                  <>
                    {CategoriesList.length > 0 && CategoriesList.map((item, i) => (

                      <option key={`SearchPageCategories${item?.unicnom}`}  value={item?.nom !== "Pack" ? item?.unicnom : "Dar-Taksit"}>{(Lang === 'ar' ? item?.nomAr : item?.nom)}</option>
                    ))
                    }
                  </>

                </select>

              </div>
              <div className="col-md-12">
                <select value={SousCategories || ""} className={`form-select ${SousCategoriesList.length == 0 && 'd-none'}`} aria-label="Default select example" onChange={(e) => setSousCategories(e.target.value)}>
                  {
                    SousCategoriesList.length == 0 && <option value={''} disabled >{(Lang === 'ar' ? 'الفئات الفرعية' : 'Sous Catégories')} </option>
                  }

                  {
                    SousCategoriesList.length > 0 && <option value={''} >{(Lang === 'ar' ? 'جميع الفئات الفرعية' : 'Tous Les Sous Catégories')} </option>
                  }

                  {SousCategoriesList.length > 0 && SousCategoriesList.map((item, i) => (
                    <option key={`SearchPagesubCategories${item?.unicnom}`}  value={item?.unicnom}>{(Lang === 'ar' ? item?.nomAr : item?.nom)}</option>
                  ))
                  }
                </select>
              </div>

            </div>
            {
              LoadingMark &&


              <Skeleton height={314} borderRadius={20} />


            }
            <div className={LoadingMark ? 'd-none' : 'sidebar-wrapper  sidebar--categories mt-5'}>
              <h5 className="sidebarBlock-heading"><svg xmlns="https://www.w3.org/2000/svg" width="25.446" height="29" viewBox="0 0 25.446 29">
                <g id="mark_icon" data-name="mark icon" transform="translate(-81.65 -174.8)">
                  <path id="Tracé_211" data-name="Tracé 211" d="M96.872,174.8c.46.106.919.218,1.379.324,1.921.442,3.842.872,5.756,1.332a1.851,1.851,0,0,1,1.444,1.467q.813,3.447,1.585,6.894a2.04,2.04,0,0,1-.566,1.986Q100,193.289,93.513,199.764a1.465,1.465,0,0,1-2.168-.006q-4.613-4.6-9.209-9.2a1.465,1.465,0,0,1,0-2.18q6.46-6.46,12.915-12.921a2.2,2.2,0,0,1,1.243-.625.646.646,0,0,0,.1-.029Zm-4.431,23.962c.035-.029.077-.071.118-.112L104.013,187.2c.465-.465.937-.931,1.4-1.4a.67.67,0,0,0,.194-.648c-.518-2.268-1.049-4.537-1.567-6.811a.588.588,0,0,0-.489-.483q-3.367-.769-6.734-1.55a.738.738,0,0,0-.754.212L83.22,189.359c-.035.035-.065.071-.088.094Z" fill="#e0234f" />
                  <path id="Tracé_212" data-name="Tracé 212" d="M94.935,437.276a1.706,1.706,0,0,1-.813-.53Q89.384,432,84.636,427.26a.629.629,0,0,0-.136-.094c.194-.194.359-.359.56-.566a.868.868,0,0,0,.094.147q4.808,4.8,9.6,9.592c.283.283.436.283.719,0l13.316-13.316a.838.838,0,0,0,.1-.124l.524.524c-.012.012-.041.047-.071.082l-13.4,13.4a1.526,1.526,0,0,1-.654.377C95.17,437.276,95.052,437.276,94.935,437.276Z" transform="translate(-2.682 -233.482)" fill="#e0234f" />
                  <path id="Tracé_213" data-name="Tracé 213" d="M392.437,251.6a1.346,1.346,0,1,1-1.337,1.343A1.33,1.33,0,0,1,392.437,251.6Z" transform="translate(-291.217 -72.274)" fill="#e0234f" />
                </g>
              </svg>{(ProductLang['Marque'][Lang])}</h5>
              <div className='search-mark'>
                {
                  Mark.length > 0 && Mark.map((item, i) => (

                    <div key={`SearchPageMark${item?.title}`} className="form-check">
                      <input className="form-check-input" type="checkbox" name={item?.title} checked={MarkChecked.includes(item?.title)} onChange={handleChange} defaultValue id={`flexCheckDefault${item?.title}`} />
                      <label className="form-check-label search-checkbox" htmlFor={`flexCheckDefault${item?.title}`}>
                        {item.title}
                      </label>
                    </div>
                  ))
                }



              </div>

            </div>
            <div onClick={() => filter()} className='search-btn mt-5 d-none'>Filtre
              <svg className='ms-2' xmlns="https://www.w3.org/2000/svg" width="23.417" height="21.964" viewBox="0 0 23.417 21.964">
                <g id="_270-2708173_cart-add-512x512-icon-online-shopping" data-name="270-2708173_cart-add-512x512-icon-online-shopping" transform="translate(-669.8 -330.1)">
                  <path id="Tracé_148" data-name="Tracé 148" d="M669.8,354.018c.238-.4.408-.463.848-.316l2.911.976c.39.128.472.248.509.665.073.857.151,1.719.229,2.595.578.087,1.142.17,1.705.257,1.284.188,2.567.38,3.851.564a.6.6,0,0,1,.555.371.538.538,0,0,1-.623.706c-.743-.105-1.481-.22-2.219-.33-.976-.147-1.948-.289-2.925-.431-.073-.009-.147-.014-.252-.023.028.339.05.656.092.972,0,.046.119.1.183.11,1.357.211,2.719.422,4.076.628l10.393,1.582c.651.1,1.3.193,1.948.3.16.027.234-.009.266-.174.06-.289.147-.573.229-.885l-1.123-.17c-1.036-.156-2.068-.307-3.1-.458a.536.536,0,0,1-.513-.628.526.526,0,0,1,.665-.431q1.939.282,3.874.573c.481.073.477.078.605-.4.055-.206.105-.413.165-.619.083-.293.248-.454.5-.463a.521.521,0,0,1,.536.348.22.22,0,0,0,.041.05v.229c-.028.087-.064.17-.087.257q-1,3.789-2.008,7.573c-.147.559-.243.633-.83.633H674.824c-.105,0-.215,0-.321,0a1.065,1.065,0,0,0-.156,2.1,1.931,1.931,0,0,0,.431.027h15.56a1.839,1.839,0,0,1,.275.009.535.535,0,0,1-.11,1.064c-.417.009-.834,0-1.284,0,.046.11.073.183.105.261a2.145,2.145,0,0,1-1.527,2.9c-.087.018-.174.041-.266.064h-.367a1.058,1.058,0,0,0-.128-.041,2.139,2.139,0,0,1-1.623-3c.023-.05.037-.11.06-.17h-7.427c.037.092.069.16.1.229a2.143,2.143,0,0,1-1.531,2.916c-.087.018-.179.041-.266.06h-.321c-.05-.014-.1-.032-.151-.041a2.14,2.14,0,0,1-1.627-3.007c.027-.06.046-.119.073-.179a2.169,2.169,0,0,1-.321-4.218c0-.073,0-.138,0-.2q-.475-5.515-.949-11.026a.278.278,0,0,0-.225-.289c-.834-.271-1.664-.559-2.5-.83a.783.783,0,0,1-.527-.431ZM675.081,367h.27q7.276,0,14.551,0c.183,0,.261-.041.312-.229.234-.926.486-1.848.729-2.769.023-.092.046-.188.078-.3-5.492-.839-10.952-1.673-16.444-2.508C674.746,363.145,674.911,365.053,675.081,367Zm2.168,5.355a1.064,1.064,0,1,0-1.059,1.068A1.07,1.07,0,0,0,677.249,372.356Zm10.122,1.064a1.066,1.066,0,1,0-1.073-1.05A1.054,1.054,0,0,0,687.372,373.419Z" transform="translate(0 -22.451)" fill="#fff" />
                  <path id="Tracé_149" data-name="Tracé 149" d="M905.713,330.1a1.487,1.487,0,0,1,.229.183.486.486,0,0,1,.105.532.491.491,0,0,1-.44.348c-.183.018-.367.023-.546.055a2.673,2.673,0,1,0,3.113,3.072c.023-.142.027-.289.037-.436a.534.534,0,1,1,1.064.055,3.6,3.6,0,0,1-2,3.246,3.718,3.718,0,0,1-5.313-4.241,3.606,3.606,0,0,1,2.984-2.76c.073-.014.147-.032.22-.05C905.346,330.1,905.53,330.1,905.713,330.1Z" transform="translate(-221.381)" fill="#fff" />
                  <path id="Tracé_150" data-name="Tracé 150" d="M950.716,379.035v.316c0,.5-.174.752-.523.756s-.536-.252-.536-.77v-.3c-.179,0-.335,0-.491,0a.535.535,0,1,1,.009-1.068c.151,0,.3,0,.486,0,0-.188,0-.353,0-.518a.53.53,0,1,1,1.059.009c0,.16,0,.316,0,.5.179,0,.335,0,.5,0a.533.533,0,0,1,.568.532.52.52,0,0,1-.555.536C951.065,379.04,950.9,379.035,950.716,379.035Z" transform="translate(-266.017 -44.653)" fill="#fff" />
                </g>
              </svg>
            </div>
          </div>
          <div className='col-12 col-lg-9 separation'>
            <div className='row mb-5 mt-5 mt-lg-0'>
              {!Loading && SearchData.length === 0 && <div className='text-center mt-5'>{(Lang === 'ar' ? 'لا توجد نتائج' : 'Pas de résultats')} <br></br>
                <img className='mt-5' width={300} src='/img/noresfound.png' />
              </div>}

              {
                Loading && SkeletonArray.map((item, i) => (


                  <div key={`SearchPageSkeletonitems${i}`} className="col text-center">
                    <Skeleton height={314} width={258} />
                  </div>

                ))
              }

              {
                SearchData.length > 0 && SearchData.map((item, i) => (


                  <div key={`SearchPage${item?.hash + i}`} className="col">
                    <Link to={`/product/${item?.hash}`} href="#">
                      <div className="card-product">
                        <div className={`first-section-product ${item?.free ? 'pb-0' : ''}`}>
                          <div className="img-product"><img alt={item?.nom} className="img-fluid" loading="lazy" src={`https://diardzair.com.dz/${item['image']}`} /></div>
                          <div className="title-product">{item?.nom?.length > 40 ? item?.nom?.substring(0, 30) + '....' : item?.nom?.substring(0, 40)}</div>
                          <div className="mark-product">{item?.marque}</div>
                        </div>
                        <div className="product-page-price price-product">
                          {/* <div className="tag-taksit">تقسيط</div> */}
                          {item?.free == false ?
                            <div className={"tag-taksit"} style={ bankActive !== 'alsalam' ? {background : "#F84771"} : {}}>
                              { bankActive == "alsalam" ?
                              <svg xmlns="http://www.w3.org/2000/svg" className='svg-tag-white' width="60" viewBox="0 0 43.966 14.86">
                              <g id="Groupe_98" data-name="Groupe 98" transform="translate(-74.461 -547.046)">
                                <path id="Tracé_236" data-name="Tracé 236" d="M361.931,550.634a.329.329,0,0,0-.2-.029c-.78,0-1.56,0-2.34,0a.421.421,0,0,0-.355.156,7.606,7.606,0,0,0-1.747,3.224.22.22,0,0,1-.248.2c-.969.025-1.935-.034-2.9-.079-.148-.007-.164-.077-.151-.2a7.271,7.271,0,0,1,4.218-6.125,7.124,7.124,0,0,1,4.786-.549c.069.015.137.035.262.067a14.329,14.329,0,0,0-3.3,2.5c.042.08.108.048.159.048.839,0,1.677,0,2.516,0a.414.414,0,0,0,.281-.1,7.314,7.314,0,0,1,1.794-1.123,1.939,1.939,0,0,1,.334-.1.386.386,0,0,1,.5.476,2.58,2.58,0,0,1-.338.845,7.72,7.72,0,0,1-2.034,2.258,10.3,10.3,0,0,1-2.58,1.471c-.047.019-.1.066-.144.035s-.012-.108,0-.162a5.961,5.961,0,0,1,1.425-2.691c.025-.029.048-.061.071-.092C361.93,550.658,361.929,550.65,361.931,550.634Z" transform="translate(-250.384 0)" fill="#038e93" />
                                <path id="Tracé_237" data-name="Tracé 237" d="M97.915,579.661a1.658,1.658,0,0,1-1.612.863c-.683,0-1.366-.022-2.048.005a1.264,1.264,0,0,1-1.386-.783c-.029.023-.05.032-.055.046a1.65,1.65,0,0,1-2.276.7,1.425,1.425,0,0,1-.546-.57c-.033-.054-.065-.139-.124-.015a1.447,1.447,0,0,1-1.632.737,1.269,1.269,0,0,1-1.04-.574c-.012.068-.018.092-.019.115-.011.34-.01.341-.36.341-.982,0-1.964-.016-2.946.006a1.285,1.285,0,0,1-1.282-.77c-.011-.022-.027-.043-.056-.09a1.681,1.681,0,0,1-.453.535,1.779,1.779,0,0,1-1.045.319c-.741,0-1.483-.007-2.224,0a1.175,1.175,0,0,1-1.06-.537.1.1,0,0,0-.086-.055,2.429,2.429,0,0,0-.081.468,3.1,3.1,0,0,1-2.436,2.491l-.019,0c-.37.071-.371.072-.526-.266-.054-.118-.17-.265-.136-.35.043-.107.23-.049.354-.068a2.426,2.426,0,0,0,2.006-1.993,3.487,3.487,0,0,0,.053-.639c0-.969,0-1.937-.014-2.905,0-.18.05-.232.23-.23.558.008.557,0,.558.562s.01,1.118,0,1.677a1.113,1.113,0,0,0,1.12,1.119c.694-.037,1.391-.01,2.087-.008a1.086,1.086,0,0,0,.646-.178.7.7,0,0,0,.328-.546c.044-.61.009-1.22,0-1.831,0-.221,0-.442-.011-.663,0-.1.031-.141.134-.137a4.244,4.244,0,0,0,.468,0c.142-.01.175.05.175.181,0,.65,0,1.3.017,1.95a1.305,1.305,0,0,0,.4.979.84.84,0,0,0,.6.245q1.3-.005,2.595,0c.146,0,.189-.044.188-.189-.006-.878,0-1.755-.008-2.633,0-.168.036-.239.214-.219a2.1,2.1,0,0,0,.39,0c.138-.01.178.044.177.179-.007.52,0,1.04,0,1.56q0,.2.017.409a1.062,1.062,0,0,0,1,1.034,2.38,2.38,0,0,0,.292.014.693.693,0,0,0,.753-.772c-.006-.741-.012-1.482-.025-2.223,0-.146.031-.221.194-.2.184.023.422-.08.542.047s.031.348.033.529c.006.455,0,.91.006,1.365a1.261,1.261,0,0,0,1.585,1.233.7.7,0,0,0,.559-.723c-.006-.851-.015-1.7-.033-2.554,0-.174.046-.233.218-.214s.416-.073.53.033.047.357.05.543c.009.507.008,1.014.008,1.521a1.359,1.359,0,0,0,.162.713.974.974,0,0,0,.9.547c.754-.012,1.509,0,2.263,0a1.4,1.4,0,0,0,.329-.029.811.811,0,0,0,.671-.857c0-.76,0-1.521-.015-2.281,0-.145.031-.2.18-.185.186.019.426-.075.548.035s.034.356.042.541c.025.571-.016,1.144.04,1.714a1.214,1.214,0,0,0,.481.9.761.761,0,0,0,.469.163c.774,0,1.548.006,2.321,0a.722.722,0,0,0,.726-.838c-.033-.661-.021-1.325-.028-1.988,0-.136,0-.273-.006-.409,0-.083.03-.116.114-.114.176,0,.351,0,.527,0,.091,0,.125.03.128.123.03.9.048,1.793.023,2.689a1.257,1.257,0,0,1-1.214,1.242c-.857.055-1.716.03-2.574.02a1.15,1.15,0,0,1-.971-.658C97.988,579.8,97.96,579.745,97.915,579.661Z" transform="translate(0 -26.316)" fill="#005043" />
                                <path id="Tracé_238" data-name="Tracé 238" d="M369.031,621.824a7.034,7.034,0,0,1-1.107,3.547,7.438,7.438,0,0,1-13.678-2.923c-.034-.234-.03-.245.21-.227q1.353.1,2.709.073c.147,0,.148.064.145.179a6.691,6.691,0,0,0,.465,2.9,3.2,3.2,0,0,0,2.7,2.106,5.205,5.205,0,0,0,2.46-.38,9.389,9.389,0,0,0,2.832-1.9,34.851,34.851,0,0,0,3.178-3.3c.021-.025.04-.051.06-.077S369.018,621.808,369.031,621.824Z" transform="translate(-250.605 -66.973)" fill="#005043" />
                                <path id="Tracé_239" data-name="Tracé 239" d="M139.169,623.585c0-.437,0-.437.439-.437.406,0,.406,0,.406.414,0,.463,0,.463-.451.463-.393,0-.393,0-.393-.4Z" transform="translate(-57.963 -68.169)" fill="#005043" />
                                <path id="Tracé_240" data-name="Tracé 240" d="M287.608,623.58c0,.444,0,.444-.453.444-.387,0-.387,0-.387-.393,0-.486,0-.486.492-.486C287.608,623.145,287.608,623.145,287.608,623.58Z" transform="translate(-190.176 -68.166)" fill="#005043" />
                                <path id="Tracé_241" data-name="Tracé 241" d="M300.689,623.586c0,.438,0,.438-.436.438-.409,0-.409,0-.409-.407,0-.471,0-.471.466-.471C300.689,623.146,300.689,623.146,300.689,623.586Z" transform="translate(-201.889 -68.167)" fill="#005043" />
                                <path id="Tracé_242" data-name="Tracé 242" d="M153.112,623.589c0,.437,0,.437-.437.437-.391,0-.391,0-.391-.39,0-.488,0-.488.471-.488.357,0,.357,0,.357.363Z" transform="translate(-69.711 -68.169)" fill="#005043" />
                                <path id="Tracé_243" data-name="Tracé 243" d="M326.057,560.139c0,.436,0,.436-.437.436-.391,0-.391,0-.391-.386,0-.48,0-.48.477-.48C326.057,559.71,326.057,559.71,326.057,560.139Z" transform="translate(-224.628 -11.344)" fill="#005043" />
                                <path id="Tracé_244" data-name="Tracé 244" d="M339.156,560.158c0,.418,0,.418-.415.418s-.414,0-.414-.423c0-.443,0-.443.439-.443C339.156,559.71,339.156,559.71,339.156,560.158Z" transform="translate(-236.36 -11.344)" fill="#005043" />
                                <path id="Tracé_245" data-name="Tracé 245" d="M315.781,632.921a.323.323,0,0,1-.334.329.332.332,0,0,1,.007-.664A.32.32,0,0,1,315.781,632.921Z" transform="translate(-215.571 -76.623)" fill="#038e93" />
                                <path id="Tracé_246" data-name="Tracé 246" d="M240.612,670.563a.323.323,0,0,1,.341.32.317.317,0,0,1-.321.337.322.322,0,0,1-.342-.317A.329.329,0,0,1,240.612,670.563Z" transform="translate(-148.543 -110.641)" fill="#038e93" />
                                <path id="Tracé_247" data-name="Tracé 247" d="M315.449,623.966a.335.335,0,0,1-.333-.331.331.331,0,0,1,.663,0A.328.328,0,0,1,315.449,623.966Z" transform="translate(-215.569 -68.31)" fill="#038e93" />
                                <path id="Tracé_248" data-name="Tracé 248" d="M233.172,670.617a.327.327,0,1,1-.319.347A.328.328,0,0,1,233.172,670.617Z" transform="translate(-141.881 -110.689)" fill="#038e93" />
                                <path id="Tracé_249" data-name="Tracé 249" d="M422.2,580.668a7.4,7.4,0,0,0-1.247-3.323c-.074-.109-.115-.128-.2-.005a8.572,8.572,0,0,1-2.1,1.982,24.519,24.519,0,0,1-4.588,2.434c-.526.223-.415.069-.43.661a3.863,3.863,0,0,0,.063.648,1.884,1.884,0,0,0,1.276,1.541,2.719,2.719,0,0,0,1.408,0,7.248,7.248,0,0,0,2.636-1.22c1.078-.738,2.076-1.582,3.087-2.407A.305.305,0,0,0,422.2,580.668Zm-1.49.953a.38.38,0,0,1-.013-.761.38.38,0,0,1,.013.761Zm.745-.562a.382.382,0,0,1-.38-.384.4.4,0,0,1,.383-.388.383.383,0,0,1,.377.389A.375.375,0,0,1,421.453,581.059Z" transform="translate(-303.81 -27.06)" fill="#038e93" />
                                <path id="Tracé_250" data-name="Tracé 250" d="M209.213,629.293c-.208-.006-.247.072-.246.26.008.93,0,1.859,0,2.789a1.139,1.139,0,0,1-.007.194.253.253,0,0,1-.307.225c-.182-.012-.134-.147-.134-.246,0-.9,0-1.807,0-2.711,0-.518,0-.51-.512-.518-.182,0-.232.057-.231.233.007.93,0,1.859,0,2.789,0,.465,0,.458-.464.457-.168,0-.209-.068-.207-.221.007-.448,0-.9,0-1.346,0-.54,0-.535-.532-.534-.161,0-.214.052-.212.213.008.487.006.975,0,1.463s.076.409-.426.425c-.177.006-.221-.058-.219-.224.008-.559,0-1.118,0-1.677,0-.12-.017-.2-.167-.2-.462.006-.924-.013-1.385.006a.971.971,0,0,0-.945,1.265.754.754,0,0,0,.52.6,1.679,1.679,0,0,0,.535.1c.213,0,.427,0,.679,0a.3.3,0,0,1-.287.127c-.6,0-1.2,0-1.795,0-.149,0-.19-.053-.188-.194.006-.468,0-.936,0-1.4,0-.513,0-.509-.522-.5-.143,0-.192.045-.19.191.007.566,0,1.131.007,1.7,0,.182-.069.22-.23.213s-.279.012-.272-.214c.015-.461,0-.923,0-1.385,0-.507,0-.5-.5-.5-.158,0-.217.043-.214.208.009.526,0,1.053,0,1.58,0,.318,0,.312-.318.313-.142,0-.195-.043-.192-.19.007-.462,0-.923,0-1.385,0-.533,0-.529-.537-.526-.148,0-.206.038-.2.2.01.5.007,1,0,1.5,0,.451.079.39-.406.4-.135,0-.181-.046-.179-.182.007-.468,0-.936,0-1.4,0-.516,0-.51-.511-.513-.168,0-.229.046-.226.221.01.468,0,.936,0,1.4s0,.471-.475.473c-.327,0-.327,0-.2-.306.015-.036.028-.073.041-.11a1.209,1.209,0,0,0-1.2-1.681c-.429.016-.859-.008-1.287.007-.2.007-.262-.064-.248-.257s0-.39,0-.585c0-.538,0-.53-.529-.535-.178,0-.217.06-.216.225.007.864,0,1.729,0,2.594,0,.571,0,.567.573.547.127,0,.172-.048.17-.172-.005-.331,0-.663,0-.995,0-.118.028-.182.162-.18.4.005.807-.008,1.209.005a.632.632,0,0,1,.661.623.785.785,0,0,1-.826.818c-.657,0-1.313,0-1.97,0-.3,0-.277-.046-.289.3-.007.185.03.259.241.259,2.712-.008,5.423,0,8.135-.01.262,0,.519-.026.787-.009.693.045,1.391.013,2.086.015a.809.809,0,0,0,.432-.1c.055-.033.1-.052.154.006a.351.351,0,0,0,.288.09c1.008,0,2.016.006,3.024,0,.52,0,.743-.242.743-.762q0-1.394,0-2.789C209.686,629.3,209.685,629.306,209.213,629.293Zm-4.583,2.764a1.615,1.615,0,0,1-.484-.03.376.376,0,0,1-.029-.715,1.3,1.3,0,0,1,.441-.043c.443,0,.446,0,.443.414S205.063,632.056,204.63,632.057Z" transform="translate(-106.894 -73.666)" fill="#038e93" />
                              </g>
                            </svg> : "تقسيط"
                            }
                            </div>
                            :
                            <div alt={'cadeaux-diardzair'} className='tag-dartaksit-category-cadeaux mt-0 mb-0'><img loading="lazy" width={'60px'} src="/img/cadeaux.png" /> </div>}
                          <div className={Lang === 'ar' ? "price d-flex" :"price" }>{(Lang === 'ar' ? <> <span className='me-1'> {( item?.free == false ? Global['Da'][Lang] : Global['Dajust'][Lang])} </span> {item?.free == false ? GetTaksitPrice(parseInt(item?.prix))['default']?.toLocaleString() : parseInt(item?.prix)?.toLocaleString()}</> : <>{item?.free == false ? GetTaksitPrice(parseInt(item?.prix))['default']?.toLocaleString() : parseInt(item?.prix)?.toLocaleString()}<span> {( item?.free == false ? Global['Da'][Lang] : Global['Dajust'][Lang] )}</span></>)}</div>
                        </div>
                      </div>
                    </Link>
                  </div>

                ))
              }


              {PageNumber > 1 &&
                <div className="text-center mt-md-5 pt-md-5 mb-5 pt-5">
                  <div className={`pagination ${Loading && 'd-none'} ${CurrentPage} ${pageQuery}`}>
                    {CurrentPage > 1 ? <a  href="#0" onClick={() => Pagination("firstPage")}>{'<<'}</a> : <a href="#0" className='non-clickable'>{'<<'}</a>}

                    {CurrentPage !== '1' ? <a href="#0" onClick={() => Pagination("Back", CurrentPage - 1)} >&laquo;</a> : <a href="#0" className='non-clickable'>&laquo;</a>}



                    {PageNumber > 0 && [...Array(PageNumber).keys()].map((item, i) => (

                      <Fragment key={`SearchPagination${item}`}>
                        {(item + 1 == (parseInt(CurrentPage) + 1) || item + 1 == (parseInt(CurrentPage) + 2) || item + 1 == (parseInt(CurrentPage) - 1) || item + 1 == (parseInt(CurrentPage) - 2) || item + 1 == CurrentPage) ?
                          <a href="#0"  onClick={() => Pagination("allPage", item + 1)} className={item + 1 == CurrentPage ? 'active' : ''}  >{item + 1}</a>
                          : ''}
                      </Fragment>

                    ))}



                    {CurrentPage < PageNumber ? <a href="#0" onClick={() => Pagination("Next", parseInt(CurrentPage) + 1)} >&raquo;</a> : <a href="#0" className='non-clickable'>&raquo;</a>}

                    {CurrentPage < PageNumber ? <a href="#0"  onClick={() => Pagination("lastPage", PageNumber)}>{'>>'}</a> : <a href="#0" className='non-clickable'>{'>>'}</a>}
                  </div>
                </div>
              }

            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Search